export enum CollectionStatus {
  DRAFT = 'draft',
  PARTICIPANTS_COLLECTION = 'participants_collection',
  MATERIALS_COLLECTION = 'materials_collection',
  POST_EDITING = 'post_editing',
  APPROVAL = 'approval',
  CHANGES_REQUIRED = 'changes_required',
  READY_TO_PUBLISH = 'ready_to_publish',
  SCHEDULED = 'scheduled',
  PUBLISHED = 'published',
  CANCELLED = 'cancelled',
}

export enum CollectionParticipantStatus {
  INVITED = 'invited',
  OPENED = 'opened',
  ACCEPTED = 'accepted',
  DECLINED = 'declined',
  WAITING_PAYMENT = 'waiting_payment',
  PAYMENT_FROZEN = 'payment_frozen',
  FILLING_MATERIALS = 'filling_materials',
  MATERIALS_SUBMITTED = 'materials_submitted',
  MATERIALS_CHANGES_REQUIRED = 'materials_changes_required',
  WAITING_POST = 'waiting_post',
  APPROVED = 'approved',
  CHANGES_REQUESTED = 'changes_requested',
  EXCLUDED = 'excluded',
  PUBLISHED = 'published',
}

export enum CollectionPublicationFormat {
  ALL_PUBLISH = 'all_publish',
  ORGANIZER_ONLY = 'organizer_only',
  PARTICIPANTS_OWN_VERSION = 'participants_own_version',
}

export enum CollectionPaymentType {
  FREE = 'free',
  PAID = 'paid',
}

export enum CollectionApprovalMode {
  STRICT = 'strict',
  EXCLUDE_SILENT = 'exclude_silent',
  MANUAL = 'manual',
}

export enum CollectionParticipantSource {
  INVITE = 'invite',
  PUBLIC_LINK = 'public_link',
}
